import React, { Component } from 'react';
import { Row, Col, Card, CardHeader, Modal, CardBody } from 'reactstrap';
import SendSubscriptionForm from '../../../../components/SendSubscriptionForm';
import EmailPreview from '../EmailPreview';

class SendSubscriptionModal extends Component {
  render() {
    const {
      isOpened,
      send,
      schedule,
      defaultLang,
      recent: { id },
      close,
    } = this.props;

    return (
      <Modal
        zIndex={1050}
        size="lg"
        className="modal-dialog-centered"
        isOpen={isOpened}
        toggle={() => close()}
        style={{ maxWidth: '90%' }}
      >
        <div className="modal-body p-0">
          <Card className="bg-secondary shadow border-0 mb-0">
            <CardHeader className="bg-transparent position-relative">
              <div className="text-muted text-center my-0">
                <p className="mb-0">Send subscription</p>
              </div>
              <a
                href="/"
                onClick={e => {
                  e.preventDefault();
                  close();
                }}
                className="position-absolute right-4 top-3 display-4"
              >
                <i className="ni ni-fat-remove text-default" />
              </a>
            </CardHeader>
            <CardBody className="px-lg-5">
              <Row>
                <Col>
                  <SendSubscriptionForm
                    handleSend={send}
                    handleSchedule={schedule}
                    initialValues={{
                      lang: defaultLang,
                      bwId: id,
                      subjectCustom: {},
                    }}
                  />
                </Col>
                <Col>
                  <EmailPreview />
                </Col>
              </Row>
            </CardBody>
          </Card>
        </div>
      </Modal>
    );
  }
}

export default SendSubscriptionModal;
